Alerts = require 'views/lib/alerts'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'
logError = require 'debug/log-error'

module.exports = class AddEmailPopoverView extends View
  viewTitleKey: 'add email'

  events:
    'click .js-save-changes': 'saveChanges'

  render: ->
    @$el.html(templates.fill('popover_add_email'))
    @

  showError: (msg, email) ->
    domain = ''
    key = switch msg.trim().toLowerCase()
      when 'the email address is already in use'
        'address in use'
      when 'this email is already on this account'
        'on account'
      when 'invalid email address'
        'invalid email address'
      when 'the email address is from a forbidden domain'
        domain = email.split('@')[1]
        'email domain forbidden'
      else
        logError new Error("Unknown server error message '#{msg}'")
        'unknown'

    @$('#account-error').text(l(['email error', key], { domain })).show()

  saveChanges: (e) ->
    Util.preventDefault(e)

    email = @$('[name="email"]').val()
    @model.run 'logins', { email }, (err) =>
      if err
        @showError(err.message, email)
      else
        PopOver.popView()
        Alerts.flash('email sent', 'confirm')
        track('Member', 'Added Email Address')
      return



// WEBPACK FOOTER //
// ./app/scripts/views/member/add-email-popover-view.coffee